import React from 'react'
import { useTranslation } from 'react-i18next'

import { createBreadcrumbWithI18n } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  PageContainer,
  type PageContainerProps,
} from '~/components/elements/PageContainer'
import { DocumentImageInfiniteScrollList } from '~/components/features/DocumentImageInfiniteScrollList'

import { useBrandAccountId } from '../hooks/useBrandAccountId'

export const DocumentImageList = () => {
  const brandAccountId = useBrandAccountId()
  const { t } = useTranslation()

  const createBreadcrumb = React.useMemo(() => createBreadcrumbWithI18n(t), [t])
  const breadcrumbs = React.useMemo<PageContainerProps['breadcrumbs']>(
    () => [
      createBreadcrumb('top', {}),
      createBreadcrumb('documentManagement'),
      createBreadcrumb('documentImageList', { brandAccountId }),
    ],
    [brandAccountId, createBreadcrumb],
  )

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <DocumentImageInfiniteScrollList
        isArchiveShown={true}
        isEnabledTransition={true}
      />
    </PageContainer>
  )
}
